import React from 'react';
import { FaInstagram } from 'react-icons/fa';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const heartIcon = new L.Icon({
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
});

const locations = [
  { id: 1, name: "Halifax", lat: 44.6488, lng: -63.5752 },
  { id: 2, name: "Annapolis Royal", lat: 44.7456, lng: -65.5153 },
  { id: 3, name: "Cape Breton", lat: 46.1351, lng: -60.1831 },
  { id: 4, name: "Truro", lat: 45.3647, lng: -63.2743 },
  { id: 5, name: "Bridgewater", lat: 44.3789, lng: -64.5184 },
];

const services = [
  {
    title: "Luxury Home Buying & Selling",
    description: "Navigating luxury home transactions with precision and discretion."
  },
  {
    title: "Exclusive Investment Properties",
    description: "Curating exclusive investment opportunities in prime locations."
  },
  {
    "title": "Prestige Property Access",
    "description": "Your gateway to elite and exclusive real estate offerings."
  },
  {
    title: "New Construction Consulting",
    description: "Guiding new construction projects with seasoned expertise."
  },
  {
    title: "Condominium Sales",
    description: "Delivering seamless condominium transactions with an elite touch."
  },
  {
    title: "Business & Commercial Real Estate",
    description: "Facilitating high-value commercial real estate ventures."
  }
];

const Services = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-800 text-white py-12 px-6 md:px-20">
      <div className="text-center mb-10">
        <h2 className="text-4xl font-extrabold text-white">Premium Real Estate Services</h2>
        <p className="text-lg text-gray-300 mt-3">
          I provide top-tier real estate services in Halifax and all over novascotia.
        </p>
      </div>

      {/* Services Section */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {services.map((service, index) => (
          <div key={index} className="bg-gray-800 p-6 rounded-lg shadow-lg hover:shadow-xl transition">
            <h3 className="text-xl font-semibold text-white">{service.title}</h3>
            <p className="text-gray-300 mt-2">{service.description}</p>
          </div>
        ))}
      </div>

      {/* Locations Map */}
      <div className="mt-12">
        <h3 className="text-3xl font-extrabold text-white text-center">Service Areas</h3>
        <p className="text-gray-300 text-center mt-3">Check out the areas where I provide premium real estate services.</p>
        <div className="w-full h-96 mt-6 relative overflow-hidden rounded-lg">
          <MapContainer
            center={[44.6488, -63.5752]}
            zoom={6}
            className="w-full h-full rounded-lg"
            style={{ position: 'relative', zIndex: 0 }}
            scrollWheelZoom={false}
            dragging={false}
          >
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            {locations.map((location) => (
              <Marker key={location.id} position={[location.lat, location.lng]} icon={heartIcon}>
                <Popup>{location.name}</Popup>
              </Marker>
            ))}
          </MapContainer>
        </div>
      </div>

      {/* Contact CTA */}
      <div className="mt-12 text-center">
        <h3 className="text-3xl font-extrabold text-white">Get Expert Guidance</h3>
        <p className="text-gray-300 mt-3">Reach out today for a premium real estate experience.</p>
        <a
          href="https://azhar-rehman.remax-ns.ca/"
          target="_blank"
          rel="noopener noreferrer"
          className="mt-6 inline-block bg-blue-600 text-white px-8 py-3 rounded-full font-semibold text-lg shadow-lg hover:bg-blue-500 transition"
        >
          View Properties
        </a>
      </div>
    </div>
  );
};

export default Services;
